export enum InternationalizationNameSpace {
  Status = 'statusTranslation',
  ErrorCodesTranslationTdrOm = 'errorCodesTranslation.tdr.om',
  ErrorCodesTranslationRoboticsOm = 'errorCodesTranslation.robotics.om',
  ErrorCodeTitleTranslationRobotics = 'errorCodeTitleTranslation.robotics',
  TechnicalInformationTranslation = 'technicalInformationTranslation',
  IncidentCommunication = 'incidentCommunicationTranslation',
  InfoItemsHistory = 'infoItemsHistory',
  Legacy = 'legacy',
  Common = 'common',
  Maintenance = 'maintenance',
  RoboticMowerDetails = 'roboticMowerDetails',
  RoboticMowersCuttingHeight = 'roboticMowersCuttingHeight',
  RoboticMowersSchedule = 'roboticMowersSchedule',
  RoboticMowers = 'roboticMowers',
  GreenkeeperTool = 'greenkeeperTool',
  CookiePolicy = 'cookiePolicy',
  AssetDetailsCommon = 'assetDetailsCommon',
  AccessGroups = 'accessGroups',
  SignUp = 'signUp',
  Login = 'login',
  InstallPrompt = 'installPrompt',
  DealerAccess = 'dealerAccess',
  Dashboard = 'dashboard',
  InventoryList = 'inventoryList',
  AssetTags = 'assetTags',
  FilterPanel = 'filterPanel',
  UserSettings = 'userSettings',
}
